const Contact = require('@/lib/Contacts/Contact');
const EntityStatus = require('@/lib/Entities/EntityStatus');
const GiftVoucher = require('@/lib/GiftVouchers/GiftVoucher');
const GiftVoucherTypeEnum = require('@/lib/GiftVouchers/GiftVoucherTypeEnum');
const SoldGiftVoucherRedeemableStatus = require('@/lib/GiftVouchers/SoldGiftVoucherRedeemableStatus');
const { toDate, toInt, toNullableFloat, toNullableString, toString } = require('@/functions/transform');

/**
 * @constructor
 */
const SoldGiftVoucher = function () {
    /**
     * @type {?number}
     */
    this.currentBalance = null;

    /**
     * @type {string}
     */
    this.deliveryType = '';

    /**
     * @type {?Date}
     */
    this.expiresAt = null;

    /**
     * @type {?GiftVoucher}
     */
    this.giftVoucher = null;

    /**
     * @type {?number}
     */
    this.ID = null;

    /**
     * @type {?string}
     */
    this.ref = null;

    /**
     * @type {?number}
     */
    this.initialBalance = null;

    /**
     * @type {?Contact}
     */
    this.recipient = null;

    /**
     * @type {?string}
     */
    this.recipientMessage = null;

    /**
     * @type {?Date}
     */
    this.redeemedAt = null;

    /**
     * @type {?Date}
     */
    this.redeemedAt = null;

    /**
     * @type {string}
     */
    this.status = 'Active';
};

SoldGiftVoucher.prototype = {
    getHydrationMap() {
        return {
            currentBalance: toNullableFloat,
            deliveryType: toString,
            expiresAt: toDate,
            giftVoucher: {
                model: GiftVoucher,
            },
            ID: {
                field: ['ID', 'soldGiftVoucherID'],
                transform: toInt,
            },
            giftVoucherID: toInt,
            ref: toString,
            status: toString,
            initialBalance: toNullableFloat,
            recipientMessage: toNullableString,
            redeemedAt: toDate,
            recipient: {
                model: Contact,
            },
        };
    },

    /**
     * @return {string}
     */
    get redeemableStatus() {
        if (this.giftVoucher?.status === EntityStatus.DELETED) {
            return SoldGiftVoucherRedeemableStatus.VOUCHER_DELETED;
        }
        if (this.isRedeemed) {
            return SoldGiftVoucherRedeemableStatus.REDEEMED;
        }
        if (this.isExpired) {
            return SoldGiftVoucherRedeemableStatus.EXPIRED;
        }
        if (this.isInactive) {
            return SoldGiftVoucherRedeemableStatus.INACTIVE;
        }
        return SoldGiftVoucherRedeemableStatus.REDEEMABLE;
    },

    /**
     * @returns {boolean}
     */
    get isRedeemed() {
        return this.redeemedAt !== null;
    },

    /**
     * @returns {boolean}
     */
    get isRedeemable() {
        return this.redeemableStatus === SoldGiftVoucherRedeemableStatus.REDEEMABLE;
    },

    /**
     * @returns {boolean}
     */
    get isInactive() {
        return this.status === SoldGiftVoucherRedeemableStatus.INACTIVE;
    },

    /**
     * @returns {boolean}
     */
    get isExpired() {
        return this.expiresAt !== null && this.expiresAt < new Date();
    },

    /**
     * @returns {boolean}
     */
    get isExperienceType() {
        return this.giftVoucher && this.giftVoucher.giftVoucherType === GiftVoucherTypeEnum.EXPERIENCE;
    },

    /**
     * @returns {boolean}
     */
    get isBalanceType() {
        return this.giftVoucher && this.giftVoucher.giftVoucherType === GiftVoucherTypeEnum.BALANCE;
    },
};

module.exports = SoldGiftVoucher;
